var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c("create-feeding-program-category", {
                attrs: {
                  "default-field-values": _vm.feedingProgramCategoryData
                },
                on: {
                  "update:defaultFieldValues": function($event) {
                    _vm.feedingProgramCategoryData = $event
                  },
                  "update:default-field-values": function($event) {
                    _vm.feedingProgramCategoryData = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "9", cols: "12" } },
            [
              _c("table-feeding-program-category", {
                on: {
                  edit: item => {
                    _vm.feedingProgramCategoryData = item
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }